function showModal(modal) {
  const modalIsNotPresent = document.body.querySelector(modal.tagName) === null;
  if (modalIsNotPresent) {
    document.body.insertAdjacentHTML('afterbegin', modal.modalCustomElement);
  }
}

function init(modal) {
  document.addEventListener(modal.event, () => showModal(modal));
}

export default {
  init,
  showModal,
};
